import { vendorPreserve } from "@pages/ManualDocumentV2/forms/_shared/preserve";
import { ComplianceDocumentType } from "@utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { siiReplacementInvoiceSchema } from "./schema";

export const siiReplacementInvoiceConfig = defineForm({
  id: "sii_replacement_invoice",
  createEndpoint: MANUAL_DOC_ENDPOINTS.SII_REPLACEMENT_INVOICE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "Invoice",
  accountClass: "AccountReceivable",
  taxRatesChannel: "SII",
  invoiceType: "regularInvoice",
  complianceType: ComplianceDocumentType.RegularInvoice,
  requiresLegalRep: true,
  titleKey: "replacement_invoice",
  complianceStandardKey: "sii",
  schema: siiReplacementInvoiceSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
  },
  omitFromPayload: ["customerCompanyAddress"],
});
